<h1 mat-dialog-title>
  {{ isEditMode ? 'Betaalplan aanpassen' : isReadOnly ? 'Betaalplan bekijken' : 'Betaalplan aanmaken' }}
</h1>

<div mat-dialog-content>
  <form [formGroup]="paymentPlanForm" class="payment-plan-form" autocomplete="off">
    <mat-form-field>
      <mat-label>Naam</mat-label>
      <input matInput formControlName="name" />
      @if (paymentPlanForm.controls.name.errors?.['required']) {
        <mat-error>Dit veld is verplicht.</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Beschrijving</mat-label>
      <textarea matInput formControlName="description" rows="4"></textarea>
      @if (paymentPlanForm.controls.description.errors?.['required']) {
        <mat-error>Dit veld is verplicht.</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Prijs</mat-label>
      <input matInput type="number" min="0" formControlName="amount" (keydown)="preventInvalidChar($event)" />
      @if (paymentPlanForm.controls.amount.errors?.['required']) {
        <mat-error>Dit veld is verplicht.</mat-error>
      }
      @if (paymentPlanForm.controls.amount.errors?.['min']) {
        <mat-error>Prijs moet 0 of hoger zijn.</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Credits</mat-label>
      <input matInput type="number" min="0" formControlName="credits" (keydown)="preventInvalidChar($event)" />
      @if (paymentPlanForm.controls.credits.errors?.['required']) {
        <mat-error>Dit veld is verplicht.</mat-error>
      }
      @if (paymentPlanForm.controls.credits.errors?.['min']) {
        <mat-error>Credits moeten 0 of hoger zijn.</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Limiet</mat-label>
      <input matInput type="number" min="0" formControlName="limit" (keydown)="preventInvalidChar($event)" />
      @if (paymentPlanForm.controls.limit.errors?.['required']) {
        <mat-error>Dit veld is verplicht.</mat-error>
      }
      @if (paymentPlanForm.controls.limit.errors?.['min']) {
        <mat-error>Limiet moet 0 of hoger zijn.</mat-error>
      }
    </mat-form-field>

    <mat-slide-toggle formControlName="visible">Actief</mat-slide-toggle>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="processing()">
    {{ isReadOnly ? 'Sluiten' : 'Annuleren' }}
  </button>
  @if (!isReadOnly) {
    <button mat-flat-button (click)="save()" [disabled]="processing()">
      {{ processing() ? 'Opslaan...' : 'Opslaan' }}
    </button>
  }
</div>
